//////////////////////////////////////////////////////////////////////////////////////   IMPORT
///////////////////////////////////////////////////////////   REACT
import React from 'react';
///////////////////////////////////////////////////////////   SETTINGS
import { _SETTINGS } from 'config/settings';
///////////////////////////////////////////////////////////   COMPS & LIBS
//import videojs from "video.js";
import WaveSurfer from 'wavesurfer.js';
import CursorPlugin from 'wavesurfer.js/src/plugin/cursor';
import ProgramPanel from '../../shared/program-panel/program-panel.component.tsx';
///////////////////////////////////////////////////////////   CSS
import './wavesurfer-player.scss';
///////////////////////////////////////////////////////////   FONTAWESOME
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas, faVolumeUp } from '@fortawesome/free-solid-svg-icons';
import { faStepBackward, faBackward, faPlay, faPause, faStepForward, faForward, faUserClock, faClock, faVolumeDown, faSearchPlus } from '@fortawesome/free-solid-svg-icons';
library.add(fas, faStepBackward, faBackward, faPlay, faPause, faStepForward, faForward, faUserClock, faClock, faVolumeDown, faVolumeUp, faSearchPlus);
//////////////////////////////////////////////////////////////////////////////////////    CLASS SETUP
export default class WaveSurferPlayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timeCode: 0,
      totalTime: 0,
      currentTime: 0,
      remainingTime: 0,
      paused: false,
      skipBackwardList: [-30, -10, -1],
      skipForwardList: [1, 10, 30],
      speedSelected: 1,
      speedList: [0.25, 0.5, 0.75, 1, 1.25, 1.5, 2.0],
      ...this.props.audioSettings
    };
  }
  ///////////////////////////////////////////////////////////   LIFECYCLE METHODS
  componentDidMount() {
    this.wavesurfer = WaveSurfer.create({
      container: document.querySelector('#waveSurferDiv'),
      backend: 'MediaElement',
      audioControls: true,
      displayMilliseconds: true,
      debug: false,
      waveColor: '#803588',
      progressColor: '#b096c2',
      cursorColor: 'red',
      backgroundColor: 'white',
      height: 250,
      hideScrollbar: true,
      normalize: true,
      partialRender: true,
      splitChannels: false,
      responsive: true,
      plugins: [
        CursorPlugin.create({
          showTime: true,
          opacity: 1,
          customShowTimeStyle: {
            'background-color': '#000',
            color: '#fff',
            padding: '2px',
            'font-size': '10px'
          }
        })
      ]
    });
    this.fetchAudioData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.audioSettings !== prevProps.audioSettings) {
      this.setState({ audioSettings: this.props.audioSettings });
    }
  }
  componentWillUnmount() {
    this.wavesurfer.destroy();
  }
  ///////////////////////////////////////////////////////////   CLASS METHODS
  /**
   * Fetch Audio Data
   * Fetch data from TAU
   * On success load, play and manage audio process
   * @param {*} audioarams
   */
  fetchAudioData = (audioarams) => {
    const { mainAudio } = this.state;
    fetch(mainAudio?.waveURL)
      .then((response) => {
        if (!response.ok) {
          throw new Error(_SETTINGS.err.audio + response.status);
        }
        return response.json();
      })
      .then((peaks) => {
        // console.log(_SETTINGS.audio.peak + peaks.sample_rate);
        this.wavesurfer.load(mainAudio.url, peaks.data);
        this.wavesurfer.on('ready', () => {
          this.setState({ totalTime: this.wavesurfer?.getDuration() });
        });
        this.wavesurfer.on('seek', () => {
          this.setState({ timeCode: this.wavesurfer.getCurrentTime() });
        });
        this.playPauseWaveSurfer();
        this.audioProcess();
      })
      .catch((e) => {
        console.error(_SETTINGS.audio.gen, e);
      });
  };
  /**
   * Audio Process
   * @param {*} params
   */
  audioProcess = (params) => {
    this.wavesurfer?.on('audioprocess', () => {
      if (this?.wavesurfer?.isPlaying()) {
        let totalTime = this.wavesurfer.getDuration(),
          timeCode = this.wavesurfer.getCurrentTime(),
          remainingTime = totalTime - timeCode;
        this.setState({ totalTime, timeCode, remainingTime });
      }
    });
  };
  /**
   * Play and pause audioplayer
   */
  playPauseWaveSurfer = () => {
    const { paused } = this.state;
    paused ? this.wavesurfer.play() : this.wavesurfer.pause();
    this.setState((prevState) => ({ paused: !prevState.paused }));
  };
  /**
   * Zoom audio
   */
  zoomWaveSurfer = () => {
    // TODO:: remove queryselector..
    let zoomValue = document.querySelector('#zoomInput').value;
    this.wavesurfer.zoom(zoomValue);
  };
  /**
   * Cahnge volume
   */
  changeVolume = () => {
    // TODO:: remove queryselector..
    let volumeValue = document.querySelector('#volumeInput').value;
    this.wavesurfer.setVolume(volumeValue);
  };
  /**
   * Cahnge speed
   */
  changeSpeed = (event, speedSelected) => {
    event.preventDefault();
    this.setState({ speedSelected });
    this.wavesurfer.setPlaybackRate(speedSelected);
  };
  /**
   * Toggle channels
   */
  toggleSplitChannels = () => {
    const { params, drawer, backend } = this.wavesurfer;
    params.splitChannels = !params.splitChannels;
    params.height = params.splitChannels ? 150 : 300;
    params.minPxPerSec <= 0 ? params.minPxPerSec++ : params.minPxPerSec--;
    params.scrollParent = true;
    this.wavesurfer.drawBuffer();
    drawer.progress(backend.getPlayedPercents());
    drawer.recenter(this.wavesurfer.getCurrentTime() / this.wavesurfer.getDuration());
    drawer.fireEvent('redraw');
  };
  /**
   * Seconds to Hmd
   * @param {*} seconds
   * @returns
   */
  secondsToHms = (fullLength) => {
    const { timeCode } = this.state;
    let seconds = Number(fullLength ? fullLength : timeCode);
    let h = Math.floor(seconds / 3600),
      m = Math.floor((seconds % 3600) / 60),
      s = Math.floor((seconds % 3600) % 60);
    seconds = seconds.toString();
    let ms = 0,
      index = seconds.indexOf('.');
    ms = index === -1 ? seconds : seconds.substring(index + 1, index + 3);
    return `${h}:${m}:${s}:${ms}`;
  };
  /**
   * Display speed list button
   * @returns jsx btn list
   */
  displaySpeedButtonList = () => {
    const { speedList, speedSelected } = this.state;
    return speedList.map((speed, k) => (
      <button key={k} onClick={(e) => this.changeSpeed(e, speed)} className={speedSelected === speed ? 'currentSpeedButton' : ''}>
        {speed}
      </button>
    ));
  };
  /**
   * Display skip list button
   * @returns jsx btn list
   */
  displaySkipButtonList = (skipList) => {
    //const { skipList } = this.state;
    return skipList.map((seconds, k) => (
      <button key={k} onClick={() => this.wavesurfer.skip(seconds)}>
        {seconds < 0 ? <FontAwesomeIcon icon={faBackward} /> : seconds} {seconds < 0 ? seconds * -1 : <FontAwesomeIcon icon={faForward} />}
      </button>
    ));
  };
  ///////////////////////////////////////////////////////////   RENDER
  render() {
    const { mainAudio, paused, totalTime } = this.state;
    return (
      <div className='wavesurferPlayerComp'>
        <div id='waveSurferDiv'></div>
        <div id='wave-timeline'></div>
        <div id='wave-minimap'></div>
        <div className='timeBar'>
          <p className='time-code'>
            <FontAwesomeIcon icon={faClock} />
            <span id='timeCode'>{this.secondsToHms()}</span> / <span>{this.secondsToHms(totalTime)}</span>
          </p>
        </div>
        <div className='toolBar'>
          <button onClick={() => this.wavesurfer.seekTo(0)}>
            <FontAwesomeIcon icon={faStepBackward} />
          </button>
          {this.displaySkipButtonList(this.state.skipBackwardList)}
          {paused ? (
            <button id='playButton' className='playBtn' onClick={this.playPauseWaveSurfer}>
              <FontAwesomeIcon icon={faPlay} />
            </button>
          ) : (
            <button id='pauseButton' className='pauseBtn' onClick={this.playPauseWaveSurfer}>
              <FontAwesomeIcon icon={faPause} />
            </button>
          )}
          {this.displaySkipButtonList(this?.state.skipForwardList)}
          <button onClick={() => this.wavesurfer.seekTo(1)}>
            <FontAwesomeIcon icon={faStepForward} />
          </button>
          <div className='volume'>
            <div className='volumeContainer'>
              <FontAwesomeIcon icon={faVolumeDown} />
              <input type='range' onChange={this.changeVolume} className='slider' id='volumeInput' name='volumeInput' min='0' max='1' defaultValue='1' step='0.1' />
              <FontAwesomeIcon icon={faVolumeUp} />
            </div>
          </div>
        </div>
        <div className='speed'>{this.displaySpeedButtonList()}</div>
        <div className='zoomBar'>
          <div className='row'>
            <div className='col-12 col-md-6 text-center text-sm-end mt-2'>
              <div className='zoom'>
                <div className='zoomContainer'>
                  <input type='range' className='slider' id='zoomInput' name='zoomInput' min='0' max='120' defaultValue='0'></input>
                  <button onClick={this.zoomWaveSurfer}>
                    <FontAwesomeIcon icon={faSearchPlus} />
                  </button>
                </div>
              </div>
            </div>
            <div className='col-12 col-md-6 text-center text-sm-start mt-2'>
              <button className='split-channels' onClick={this.toggleSplitChannels}>
                Csatornák váltása
              </button>
            </div>
          </div>
        </div>
        <ProgramPanel programData={mainAudio} />
      </div>
    );
  }
}
